import { useState } from 'react';

const Footer = () => {
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleWhatsApp = () => {
    const message = encodeURIComponent('Olá! Gostaria de saber mais sobre os serviços da MãoForte.');
    window.open(`https://wa.me/5524992076773?text=${message}`, '_blank');
  };

  const handleInstagram = () => {
    window.open('https://instagram.com/maoforte_ofc', '_blank');
  };

  const handleEmail = () => {
    window.open('mailto:maoforte25@gmail.com', '_blank');
  };

  const handlePhone = () => {
    window.open('tel:+5524992076773', '_blank');
  };

  return (
    <>
      <footer className="bg-slate-800 text-white py-12 md:py-16">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
            {/* Logo e Descrição */}
            <div className="md:col-span-1">
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <img 
                    src="https://static.readdy.ai/image/62550bc47b27f12b31ed19b5600db8cd/ec269de17ab2b3f3aaea809d27439652.jpeg"
                    alt="MãoForte Logo"
                    className="w-12 h-12 md:w-10 md:h-10 object-cover rounded-full"
                  />
                </div>
                <p className="text-slate-300 md:text-slate-400 text-base md:text-base leading-relaxed">
                  Conectamos você aos melhores profissionais da construção civil.
                </p>
              </div>
            </div>

            {/* Links Rápidos */}
            <div className="md:col-span-1">
              <h4 className="text-xl md:text-xl font-semibold mb-6 md:mb-6">Links Rápidos</h4>
              <ul className="space-y-3 md:space-y-3">
                <li>
                  <button 
                    onClick={() => scrollToSection('sobre')}
                    className="text-slate-300 md:text-slate-400 hover:text-orange-400 transition-colors cursor-pointer text-base md:text-base font-medium"
                  >
                    Sobre Nós
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('como-funciona')}
                    className="text-slate-300 md:text-slate-400 hover:text-orange-400 transition-colors cursor-pointer text-base md:text-base font-medium"
                  >
                    Como Funciona
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('vantagens')}
                    className="text-slate-300 md:text-slate-400 hover:text-orange-400 transition-colors cursor-pointer text-base md:text-base font-medium"
                  >
                    Vantagens
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('beneficios')}
                    className="text-slate-300 md:text-slate-400 hover:text-orange-400 transition-colors cursor-pointer text-base md:text-base font-medium"
                  >
                    Benefícios
                  </button>
                </li>
              </ul>
            </div>

            {/* Contato */}
            <div className="md:col-span-1">
              <h4 className="text-xl md:text-xl font-semibold mb-6 md:mb-6">Contato</h4>
              <div className="space-y-3 md:space-y-3">
                <p className="text-slate-300 md:text-slate-400 text-base md:text-base">
                  <i className="ri-phone-line mr-2 text-lg"></i>
                  <a 
                    href="https://wa.me/5524992076773?text=Olá!%20Vim%20através%20do%20site%20MãoForte%20e%20gostaria%20de%20saber%20mais%20informações."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-orange-400 transition-colors"
                  >
                    +55 24 99207-6773
                  </a>
                </p>
                <p className="text-slate-300 md:text-slate-400 text-base md:text-base">
                  <i className="ri-mail-line mr-2 text-lg"></i>
                  <a href="mailto:maoforte25@gmail.com" className="hover:text-orange-400 transition-colors">
                    maoforte25@gmail.com
                  </a>
                </p>
              </div>
            </div>

            {/* Redes Sociais */}
            <div className="md:col-span-1">
              <h4 className="text-xl md:text-xl font-semibold mb-6 md:mb-6">Redes Sociais</h4>
              <div className="flex space-x-4">
                <a 
                  href="https://wa.me/5524992076773?text=Olá!%20Vim%20através%20do%20site%20MãoForte%20e%20gostaria%20de%20saber%20mais%20informações."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 md:w-10 md:h-10 flex items-center justify-center bg-slate-700 rounded-full hover:bg-green-500 transition-colors"
                >
                  <i className="ri-whatsapp-line text-xl md:text-lg"></i>
                </a>
                <a 
                  href="https://instagram.com/maoforte_ofc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 md:w-10 md:h-10 flex items-center justify-center bg-slate-700 rounded-full hover:bg-pink-500 transition-colors"
                >
                  <i className="ri-instagram-line text-xl md:text-lg"></i>
                </a>
                <a 
                  href="mailto:maoforte25@gmail.com"
                  className="w-12 h-12 md:w-10 md:h-10 flex items-center justify-center bg-slate-700 rounded-full hover:bg-blue-500 transition-colors"
                >
                  <i className="ri-mail-line text-xl md:text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Linha divisória */}
          <div className="border-t border-slate-700 mt-8 md:mt-12 pt-6 md:pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="flex flex-col items-center md:items-start space-y-3">
                <p className="text-sm md:text-sm text-slate-400 text-center md:text-left">
                  © 2024 MãoForte. Todos os direitos reservados.
                </p>
                <p className="text-base md:text-lg font-medium italic text-orange-400 text-center md:text-left">
                  "Tudo o que fizerem, façam de todo o coração" - Colossenses 3:23
                </p>
              </div>
              <div className="flex flex-wrap justify-center md:justify-end items-center space-x-4 md:space-x-6">
                <button 
                  onClick={() => setShowPrivacyModal(true)}
                  className="text-sm md:text-sm text-slate-400 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Política de Privacidade
                </button>
                <button 
                  onClick={() => setShowTermsModal(true)}
                  className="text-sm md:text-sm text-slate-400 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Termos de Uso
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal de Política de Privacidade */}
      {showPrivacyModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-4xl max-h-[80vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-slate-800">Política de Privacidade</h2>
                <button 
                  onClick={() => setShowPrivacyModal(false)}
                  className="w-8 h-8 flex items-center justify-center text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-full transition-colors"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              
              <div className="prose prose-slate max-w-none">
                <h3 className="text-lg font-semibold text-slate-800 mb-3">Quem somos</h3>
                <p className="text-slate-600 mb-4">
                  A MãoForte é uma plataforma digital que atua como intermediadora, conectando clientes que precisam de serviços 
                  a profissionais autônomos e prestadores de serviços, sem vínculo empregatício entre as partes.
                </p>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">1. Dados que coletamos</h3>
                <p className="text-slate-600 mb-2">
                  Podemos coletar os seguintes dados, conforme a interação do usuário com a plataforma:
                </p>
                
                <p className="text-slate-600 mb-2 mt-4">
                  <strong>1.1 Dados fornecidos pelo usuário:</strong>
                </p>
                <ul className="list-disc list-inside text-slate-600 mb-4 ml-4">
                  <li>Nome completo</li>
                  <li>CPF</li>
                  <li>Telefone</li>
                  <li>E-mail</li>
                  <li>Endereço (quando necessário para prestação do serviço)</li>
                  <li>Foto de perfil</li>
                  <li>Informações profissionais (categoria, experiência, disponibilidade)</li>
                </ul>

                <p className="text-slate-600 mb-2">
                  <strong>1.2 Dados de uso:</strong>
                </p>
                <ul className="list-disc list-inside text-slate-600 mb-4 ml-4">
                  <li>Data e horário de acesso</li>
                  <li>Interações com a plataforma</li>
                  <li>Informações técnicas do dispositivo (IP, navegador, sistema operacional)</li>
                </ul>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">2. Finalidade do uso dos dados</h3>
                <p className="text-slate-600 mb-2">Os dados coletados são utilizados para:</p>
                <ul className="list-disc list-inside text-slate-600 mb-4 ml-4">
                  <li>Identificação e autenticação dos usuários</li>
                  <li>Intermediação entre clientes e profissionais</li>
                  <li>Comunicação sobre solicitações, serviços e suporte</li>
                  <li>Criação de histórico, avaliações e reputação na plataforma</li>
                  <li>Cumprimento de obrigações legais e regulatórias</li>
                  <li>Aumento da segurança e prevenção a fraudes</li>
                </ul>
                <p className="text-slate-600 mb-4">
                  A MãoForte não utiliza dados pessoais para fins ilegais ou não autorizados.
                </p>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">3. Compartilhamento de dados</h3>
                <p className="text-slate-600 mb-4">
                  A MãoForte não vende dados pessoais. O compartilhamento pode ocorrer apenas nos seguintes casos:
                </p>
                <ul className="list-disc list-inside text-slate-600 mb-4 ml-4">
                  <li>Entre cliente e profissional, somente quando necessário para a execução do serviço</li>
                  <li>Com fornecedores de tecnologia e parceiros, respeitando a LGPD</li>
                  <li>Por obrigação legal, ordem judicial ou solicitação de autoridades competentes</li>
                </ul>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">4. Verificação e segurança</h3>
                <p className="text-slate-600 mb-4">
                  Alguns profissionais podem optar por processos de verificação adicional, que podem envolver consultas a bases públicas, 
                  quando legalmente permitidas. A MãoForte não divulga detalhes sensíveis dessas verificações, utilizando apenas 
                  indicadores de status (ex.: verificado / não verificado).
                </p>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">5. Armazenamento e segurança dos dados</h3>
                <p className="text-slate-600 mb-2">
                  Adotamos medidas técnicas e organizacionais para proteger os dados pessoais contra:
                </p>
                <ul className="list-disc list-inside text-slate-600 mb-4 ml-4">
                  <li>Acesso não autorizado</li>
                  <li>Uso indevido</li>
                  <li>Perda ou alteração</li>
                </ul>
                <p className="text-slate-600 mb-4">
                  Apesar dos esforços, nenhum sistema é 100% seguro, e a MãoForte não pode garantir segurança absoluta.
                </p>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">6. Responsabilidades</h3>
                <ul className="list-disc list-inside text-slate-600 mb-4 ml-4">
                  <li>A MãoForte não é empregadora dos profissionais cadastrados</li>
                  <li>Cada serviço realizado é de responsabilidade direta entre cliente e profissional</li>
                  <li>A MãoForte atua exclusivamente como intermediadora tecnológica, oferecendo meios de conexão, reputação e organização</li>
                </ul>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">7. Direitos do titular de dados</h3>
                <p className="text-slate-600 mb-2">
                  Nos termos da LGPD, o usuário pode solicitar:
                </p>
                <ul className="list-disc list-inside text-slate-600 mb-4 ml-4">
                  <li>Acesso aos seus dados</li>
                  <li>Correção de dados incorretos</li>
                  <li>Exclusão de dados, quando aplicável</li>
                  <li>Revogação de consentimento</li>
                </ul>
                <p className="text-slate-600 mb-4">
                  Solicitações podem ser feitas pelos canais oficiais da MãoForte.
                </p>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">8. Retenção de dados</h3>
                <p className="text-slate-600 mb-2">
                  Os dados serão armazenados apenas pelo tempo necessário para:
                </p>
                <ul className="list-disc list-inside text-slate-600 mb-4 ml-4">
                  <li>Cumprimento das finalidades descritas</li>
                  <li>Atendimento a obrigações legais</li>
                  <li>Exercício regular de direitos</li>
                </ul>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">9. Alterações nesta Política</h3>
                <p className="text-slate-600 mb-4">
                  A MãoForte pode atualizar esta Política de Privacidade a qualquer momento. 
                  Recomenda-se a revisão periódica deste documento.
                </p>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">10. Contato</h3>
                <p className="text-slate-600 mb-4">
                  Em caso de dúvidas sobre esta Política ou sobre o tratamento de dados pessoais, entre em contato pelos canais oficiais da MãoForte:
                </p>
                <ul className="list-none text-slate-600 mb-4 ml-4">
                  <li><strong>E-mail:</strong> maoforte25@gmail.com</li>
                  <li><strong>WhatsApp:</strong> +55 24 99207-6773</li>
                </ul>

                <p className="text-sm text-slate-500 mt-6">
                  Última atualização: Dezembro de 2024
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Termos de Uso */}
      {showTermsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-4xl max-h-[80vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-slate-800">Termos de Uso</h2>
                <button 
                  onClick={() => setShowTermsModal(false)}
                  className="w-8 h-8 flex items-center justify-center text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-full transition-colors"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              
              <div className="prose prose-slate max-w-none">
                <h3 className="text-lg font-semibold text-slate-800 mb-3">1. Aceitação dos Termos</h3>
                <p className="text-slate-600 mb-4">
                  Ao acessar e usar a plataforma MãoForte, você concorda em cumprir e estar vinculado a estes Termos de Uso. 
                  Se você não concordar com qualquer parte destes termos, não deve usar nossos serviços.
                </p>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">2. Descrição do Serviço</h3>
                <p className="text-slate-600 mb-4">
                  A MãoForte é uma plataforma digital que conecta clientes a profissionais qualificados da construção civil 
                  na Região dos Lagos, RJ. Facilitamos o contato entre as partes, mas não somos responsáveis pela execução 
                  dos serviços contratados.
                </p>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">3. Responsabilidades dos Usuários</h3>
                <p className="text-slate-600 mb-2">
                  <strong>Clientes:</strong>
                </p>
                <ul className="list-disc list-inside text-slate-600 mb-4 ml-4">
                  <li>Fornecer informações precisas sobre o projeto</li>
                  <li>Tratar os profissionais com respeito</li>
                  <li>Cumprir os acordos estabelecidos</li>
                </ul>
                
                <p className="text-slate-600 mb-2">
                  <strong>Profissionais:</strong>
                </p>
                <ul className="list-disc list-inside text-slate-600 mb-4 ml-4">
                  <li>Possuir qualificações adequadas para os serviços oferecidos</li>
                  <li>Fornecer orçamentos honestos e detalhados</li>
                  <li>Executar os trabalhos com qualidade e pontualidade</li>
                  <li>Manter documentação e licenças em dia</li>
                </ul>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">4. Limitação de Responsabilidade</h3>
                <p className="text-slate-600 mb-4">
                  A MãoForte atua apenas como intermediária na conexão entre clientes e profissionais. Não nos responsabilizamos 
                  por disputas, danos, qualidade dos serviços executados ou questões contratuais entre as partes.
                </p>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">5. Privacidade e Dados</h3>
                <p className="text-slate-600 mb-4">
                  Respeitamos sua privacidade e protegemos seus dados pessoais conforme nossa Política de Privacidade. 
                  As informações coletadas são utilizadas exclusivamente para melhorar nossos serviços e facilitar conexões.
                </p>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">6. Modificações dos Termos</h3>
                <p className="text-slate-600 mb-4">
                  Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações entrarão em vigor 
                  imediatamente após a publicação no site. É responsabilidade do usuário verificar periodicamente os termos atualizados.
                </p>

                <h3 className="text-lg font-semibold text-slate-800 mb-3">7. Contato</h3>
                <p className="text-slate-600 mb-4">
                  Para dúvidas sobre estes Termos de Uso, entre em contato conosco através do email maoforte25@gmail.com 
                  ou WhatsApp +55 24 99207-6773.
                </p>

                <p className="text-sm text-slate-500 mt-6">
                  Última atualização: Dezembro de 2024
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export { Footer };
export default Footer;